import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useTypedParams, useTypedSearchParams } from 'react-router-typesafe-routes';
import ForwardForm from '@/components/scan-code/forward-form';
import useBatchForward, { type ForwardTarget } from '@/hooks/forward/use-batch-forward';
import type { ConversationType } from '@/models/conversations/conversation-session';
import ROUTES from '@/routes';

type Props = {
  type: ConversationType;
};

export default function ForwardMessageRoute({ type }: Props) {
  const [{ messageIds }] = useTypedSearchParams(ROUTES.MESSAGES.GROUPS.FORWARD);
  const { id } = useTypedParams(ROUTES.MESSAGES.GROUPS.FORWARD);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsyncWithPrompt, isPending: isForwarding } = useBatchForward();

  const handleForward = async (targets: ForwardTarget[], clearSelection: () => void) => {
    if (await mutateAsyncWithPrompt({ sessionType: type, sessionId: id, messageIds, targets })) {
      navigate(-1);
      clearSelection();
    }
  };

  return (
    <ForwardForm
      navigateBack
      onForward={handleForward}
      isLoading={isForwarding}
      title={t('conversation.forward.title')}
    />
  );
}
